/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayPortsControlToggle_ConfigFragment = { __typename: 'ConfigurationModel', id: string, portsControl?: { __typename: 'ConfigPortsControlState', reported: Types.ConfigPortsControlLockState, supportedValues: Array<Types.ConfigPortsControlLockState> } | null };

export type ConfigUpdatePortsControlMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdatePortsControlInput;
}>;


export type ConfigUpdatePortsControlMutation = { __typename: 'Mutation', configurationBulkUpdatePortsControl: { __typename: 'ConfigurationModel', id: string, portsControl?: { __typename: 'ConfigPortsControlState', reported: Types.ConfigPortsControlLockState, supportedValues: Array<Types.ConfigPortsControlLockState> } | null } };

export const ConfigDisplayPortsControlToggle_ConfigFragmentDoc = gql`
    fragment ConfigDisplayPortsControlToggle_config on ConfigurationModel {
  id
  portsControl {
    reported
    supportedValues
  }
}
    `;
export const ConfigUpdatePortsControlDocument = gql`
    mutation ConfigUpdatePortsControl($input: ConfigurationUpdatePortsControlInput!) {
  configurationBulkUpdatePortsControl(input: $input) {
    id
    portsControl {
      reported
      supportedValues
    }
  }
}
    `;
export type ConfigUpdatePortsControlMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdatePortsControlMutation, ConfigUpdatePortsControlMutationVariables>;

/**
 * __useConfigUpdatePortsControlMutation__
 *
 * To run a mutation, you first call `useConfigUpdatePortsControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdatePortsControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdatePortsControlMutation, { data, loading, error }] = useConfigUpdatePortsControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdatePortsControlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdatePortsControlMutation, ConfigUpdatePortsControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdatePortsControlMutation, ConfigUpdatePortsControlMutationVariables>(ConfigUpdatePortsControlDocument, options);
      }
export type ConfigUpdatePortsControlMutationHookResult = ReturnType<typeof useConfigUpdatePortsControlMutation>;
export type ConfigUpdatePortsControlMutationResult = ApolloReactCommon.MutationResult<ConfigUpdatePortsControlMutation>;
export type ConfigUpdatePortsControlMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdatePortsControlMutation, ConfigUpdatePortsControlMutationVariables>;